import fetch from 'cross-fetch';
import get from 'lodash/get';
import { ApiV1Base, ApiPrefixV1, statusCheck, getCookie, json } from 'util/icwUtility';
import { apiCreateDocument } from 'modules/inspection/api';
import { getResponseFileInfo } from 'util/file';
import { SharedTypes } from './types';

//-------------------------------------------------
// UPLOAD_FILE
export function uploadFileLoading(id) {
  return { type: SharedTypes.UPLOAD_FILE.LOADING, payload: id };
}

export function uploadFileSuccess(id, data) {
  return { type: SharedTypes.UPLOAD_FILE.SUCCESS, payload: { id, data } };
}

export function uploadFileError(id, error) {
  return { type: SharedTypes.UPLOAD_FILE.ERROR, payload: { id, error } };
}

export function uploadFileReset() {
  return { type: SharedTypes.UPLOAD_FILE.RESET };
}

export function uploadFile(id, formData, cb, errCb, isNewApi = false, uploadDocument) {
  
  return (dispatch) => {
    dispatch(uploadFileLoading(id));
    const url = isNewApi ? `${ApiPrefixV1}/upload/multiple/file` : `${ApiPrefixV1}/upload`;
    const fetchOption = {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
      },
      body: formData,
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then(async (res) => {
        if (uploadDocument) {
          const params = {
            documentLists: res?.data?.map((uploaded) => {
              return {
                fileSize: 0,
                filePath: uploaded.name.split('/')[0],
                fileName: uploaded.name.split('/')[1],
                mineType: uploaded.mineType,
              };
            }),
          };
          const { data: createdDocument } = await apiCreateDocument(params);
          const tDocument = createdDocument?.data?.[0];
          const {
            name: fName,
            url: fUrl,
            fileSize,
            fileType,
          } = getResponseFileInfo(get(res, `data${ApiPrefixV1 ? '.0' : ''}`, {}));
          const fileObj = {
            filePath: tDocument?.filePath,
            fileName: tDocument?.fileName,
            name: fName,
            url: fUrl,
            fileSize,
            fileType,
            id: tDocument?.id,
          };
          dispatch(uploadFileSuccess(id, fileObj));
          if (cb) cb(id, fileObj);
        } else {
          const {
            fileName,
            filePath,
            name: fName,
            url: fUrl,
            fileSize,
            fileType,
          } = getResponseFileInfo(get(res, `data${ApiPrefixV1 ? '.0' : ''}`, {}));
          const fileObj = {
            filePath,
            fileName,
            name: fName,
            url: fUrl,
            fileSize,
            fileType,
          };
  
          dispatch(uploadFileSuccess(id, fileObj));
          if (cb) cb(id, fileObj);
        }
        
      })
      .catch((err) => {
        dispatch(uploadFileError(id, typeof err === 'object' ? err.message : err));
        if (errCb) errCb();
      });
  };
}

//-------------------------------------------------
// UPLOAD_MULTIPLE_FILE
export function uploadMultipleFileLoading(id) {
  return { type: SharedTypes.UPLOAD_MULTIPLE_FILE.LOADING, payload: id };
}

export function uploadMultipleFileSuccess(id, data) {
  return { type: SharedTypes.UPLOAD_MULTIPLE_FILE.SUCCESS, payload: { id, data } };
}

export function uploadMultipleFileError(id, error) {
  return { type: SharedTypes.UPLOAD_MULTIPLE_FILE.ERROR, payload: { id, error } };
}

export function uploadMultipleFileReset() {
  return { type: SharedTypes.UPLOAD_MULTIPLE_FILE.RESET };
}

export function uploadMultipleFile(id, formData, cb, errCb, uploadDocument) {
  return (dispatch) => {
    dispatch(uploadMultipleFileLoading(id));
    const url = `${ApiV1Base}${ApiPrefixV1}/upload/multiple/file`;
    const fetchOption = {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
      },
      body: formData,
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then(async (res) => {
        if (uploadDocument) {
          const params = {
            documentLists: res?.data?.map((uploaded) => {
              return {
                fileSize: 0,
                filePath: uploaded.name.split('/')[0],
                fileName: uploaded.name.split('/')[1],
                mineType: uploaded.mineType,
              };
            }),
          };
          const { data: createdDocument } = await apiCreateDocument(params);
          const resFiles = (get(res, 'data') || []).map((f, index) => {
            const tDocument = createdDocument?.data?.[index];
            const {
              name: fName,
              url: fUrl,
              fileSize,
              fileType,
            } = getResponseFileInfo(f);
            return {
              id: tDocument.id,
              filePath: tDocument.filePath,
              fileName: tDocument.fileName,
              name: fName,
              url: fUrl,
              size: fileSize,
              type: fileType,
            };
          });
          dispatch(uploadMultipleFileSuccess(id, resFiles));
          if (cb) cb(id, resFiles);
        } else {
          const resFiles = (get(res, 'data') || []).map((f) => {
            const {
              id,
              fileName,
              filePath,
              name: fName,
              url: fUrl,
              fileSize,
              fileType,
            } = getResponseFileInfo(f);
            return {
              id,
              filePath,
              fileName,
              name: fName,
              url: fUrl,
              size: fileSize,
              type: fileType,
            };
          });
          dispatch(uploadMultipleFileSuccess(id, resFiles));
          if (cb) cb(id, resFiles);
        }
      })
      .catch((err) => {
        dispatch(uploadMultipleFileError(id, typeof err === 'object' ? err.message : err));
        if (errCb) errCb();
      });
  };
}
